import React, { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { UseContextApp } from "../../Global/Context/appContext";
import { colors } from "../../propsType/Colors";
import AuthController from "../../controllers/AuthController";
import ModalSesion from "../../components/Modals/Modal";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
const Profile = () => {
  const navigate = useNavigate();
  //Se trae desde el contexto global todos los datos de la variable user
  const [{ user }] = UseContextApp();
  const { recoverEmail,signOut } = AuthController();
  const [correo, setCorreo] = useState([""]);
  const [selected, setSelected] = useState("");
  const [eailState, setEailState] = useState(false);
  const [loading, setloading] = useState(false)
  const [message, setmessage] = useState('')
  const [errorMessage, setErrorMessage] = useState(false)
  const [messageSesion, setMessageSesion] = useState("");
  const [modal, setModal] = useState(false);
  const getCorreo = () => {
    setCorreo(user?.datos?.correos);
  };

  const exit = async () => {
    const res = await signOut(user);
    setTimeout(() => {
        localStorage.clear()
        navigate('/cuenta');
      }, 1);
    
  }

  const changeOptions = async (string) => {
    if (selected) {
    
      setloading(true)
      let newObjet = {
        email: selected.id
      }
      const res = await recoverEmail(newObjet)
      if (res.respuesta === "0") {
        setmessage(res.descripcion)
        setloading(false);
        setErrorMessage(false)
        setModal(true);
        setMessageSesion("Cerraremos tu sesión para que reestablezcas tu contraseña.")

      } else {
        setErrorMessage(true)
        setmessage("Ha ocurrido un error, intente mas tarde")
        setloading(false)
        setTimeout(() => {
          setmessage(null)
        }, 1500);
      }
    }
  };

  useEffect(() => {
    if (!selected) {
      setEailState(true);
    } else {
      setEailState(false);
    }
  }, [selected]);

  useEffect(() => {
  
    getCorreo();
  }, []);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  return (
    <>
      <div className="bg-white shadow-xl rounded-lg overflow-hidden">
        <div className="min-h-full">
          <main className="py-10">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
              <div className="flex items-center space-x-5">
                <div className="flex-shrink-0">
                  <div className="relative">
                    {user?.img ? (
                      <>
                        <img
                          className="h-16 w-16 rounded-full"
                          src="https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                          alt=""
                        />
                      </>
                    ) : (
                      <>
                        <div className="flex-shrink-0">
                          <div
                            className={`mx-auto border-[#00000052] shadow-lg flex border-2 justify-center items-center bg-[${colors.lightBlue}] border-black  h-20 w-20 rounded-full`}
                          >
                            <div>
                              <span className="font-medium text-[#fff] ">
                                {" "}
                                {user?.initial || "NA"}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <span
                      className="absolute inset-0 shadow-inner rounded-full"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    {user?.datos?.nombreApellido}{" "}
                  </h1>
                  <p className="text-sm font-medium text-gray-500">
                    {user?.datos?.tipoCliente}{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
              <div className="space-y-6 lg:col-start-1 lg:col-span-2">
                <section aria-labelledby="applicant-information-title">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:px-6">
                      <h2
                        id="applicant-information-title"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Información de tu cuenta
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm text-gray-500">
                        Datos del Titular
                      </p>
                    </div>
                    <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Número de Abonado
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {user?.datos?.ctaAbonado}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Correo Electrónico
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {user?.datos?.maskEmail}{" "}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Ciudad
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {user?.datos?.ciudad || "Caracas"}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Teléfono
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {user?.datos?.maskTelefono}
                          </dd>
                        </div>
                      </dl>
                    </div>
                    <div>
                      <a
                        href="#"
                        className="block bg-gray-50 text-sm font-medium text-gray-500 text-center px-4 py-4 hover:text-gray-700 sm:rounded-b-lg"
                      >
                        {/*  Datos de tu cuenta */}
                      </a>
                    </div>
                  </div>
                </section>
              </div>
              <section
                aria-labelledby="timeline-title"
                className="lg:col-start-3 lg:col-span-1"
              >
                <section aria-labelledby="applicant-information-title">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:px-6">
                      <h2
                        id="applicant-information-title"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Cambio de Contraseña
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm text-gray-500">
                        Selecciona la dirección de correo electrónico, donde
                        recibirás un email para realizar el cambio de contraseña
                      </p>
                    </div>
                    <div className="border-t border-gray-200 ">
                      <dl className="grid grid-cols-1 gap-x-4">
                        <RadioGroup
                          value={selected}
                          onChange={setSelected}
                          className="mt-1 overflow-y-auto lisCard h-auto pb-1  pr-3"
                        >
                          <div className="relative bg-white grid gap-5 p-[10px] rounded-md -space-y-px">
                            {correo.map((email, emailIdx) => (
                              <RadioGroup.Option
                                key={emailIdx}
                                value={email}
                                className={({ checked }) =>
                                  classNames(
                                    emailIdx === 0
                                      ? "rounded-tl-md rounded-tr-md"
                                      : "",
                                    emailIdx === correo.length - 1
                                      ? "rounded-bl-md rounded-br-md"
                                      : "",
                                    checked
                                      ? "bg-indigo-50 border-indigo-200 z-10"
                                      : "border-gray-200",
                                    "relative border p-4   md:pl-4 md:pr-6 focus:outline-none cursor-pointer"
                                  )
                                }
                              >
                                {({ active, checked }) => (
                                  <>
                                    <div className="flex items-center justify-between text-lg">
                                      <div className="flex items-center justify-between ">
                                        <span
                                          className={classNames(
                                            checked
                                              ? `bg-[${colors.lightBlue}] border-transparent`
                                              : " border-gray-300 bg-white ",
                                            active
                                              ? "ring-2 ring-offset-2 ring-[#5AB9E5] "
                                              : "",
                                            "h-4 w-4 rounded-full border flex items-center justify-center "
                                          )}
                                          aria-hidden="true"
                                        >
                                          <span className="rounded-full bg-white w-1.5 h-1.5" />
                                        </span>
                                        <RadioGroup.Label
                                          as="span"
                                          className={classNames(
                                            checked
                                              ? "text-indigo-900"
                                              : "text-gray-400",
                                            "ml-3 lowercase font-medium"
                                          )}
                                        >
                                          {email.correo}
                                        </RadioGroup.Label>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </RadioGroup.Option>
                            ))}
                          </div>
                        </RadioGroup>
                        <div className="pr-0 mt-0 m-4 w-[90%] ">
                          {
                            message ? (
                              <>
                                {
                                  errorMessage ?
                                    (
                                      <>

                                        <div class="bg-red-100 border-t-4 border-red-500  rounded-[5px] text-red-900 px-4 py-1 shadow-md" role="alert">
                                          <div class="flex">
                                            <div class="py-1"><svg class="fill-current h-6 w-6 text-red-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                                            <div>
                                              <p class="text-sm">{message} </p>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )
                                    :
                                    (
                                      <>

                                        <div class="bg-[#eef2ff] border-t-4 border-[#5AB9E5]  rounded-[5px] text-teal-900 px-4 py-1 shadow-md" role="alert">
                                          <div class="flex">
                                            <div class="py-1"><svg class="fill-current h-6 w-6 text-[#5AB9E5] mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                                            <div>
                                              <p class="text-sm">{message} </p>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )
                                }


                              </>
                            )
                              :
                              (
                                <>
                                  <button
                                    disabled={eailState}
                                    onClick={changeOptions}
                                    className={` ${eailState
                                      ? "bg-gray-400"
                                      : `bg-[${colors.darkBlue}]`
                                      } block  w-full text-sm   font-medium text-white text-center px-2 py-2 hover:text-white sm:rounded-b-lg`}
                                  >
                                    {
                                      loading ? 'Solicitando...' : ' Solicitar Cambio de Contraseña'
                                    }

                                  </button>
                                </>
                              )
                          }

                        </div>
                      </dl>
                    </div>
                  </div>
                </section>
              </section>
            </div>
          </main>
        </div>
      </div>
      <ModalSesion
        message={messageSesion}
        active={modal}
        setActive={setModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            // onClick={() => setErros(false)}
            onClick={() => {setModal(false) 
                            exit()}}
            //className="hover:border-[#09101F] hover:text-[#09101F]  hover:bg-white w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-all ease-linear 1s"
            className="inline-flex w-full justify-center rounded-md bg-[#09101F] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#09101F] sm:ml-3 sm:w-auto"
          >
            Cerrar
          </button>
        </div>
      </ModalSesion>
    </>
  );
};

export default Profile;
